/* Wishlist page: renders saved products (localStorage "shopify-wishlist") from /products/<handle>.js.
   Supports add to cart, remove, move all, clear, and share links (?items=a,b,c). */
(function () {
  if (customElements.get('wishlist-page')) return;

  var KEY = 'shopify-wishlist';
  var store = {
    get: function () {
      if (window.AmWishlist) return window.AmWishlist.get();
      try { var r = localStorage.getItem(KEY); return r ? r.split(',').filter(Boolean) : []; } catch (e) { return []; }
    },
    set: function (items) {
      if (window.AmWishlist) return window.AmWishlist.set(items);
      try { if (items.length) localStorage.setItem(KEY, items.join(',')); else localStorage.removeItem(KEY); } catch (e) {}
      document.querySelectorAll('.wishlist__count').forEach(function (el) { el.innerText = items.length; });
      return items;
    }
  };

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  function formatMoney(cents, format) {
    var value = (cents / 100);
    var fixed2 = value.toFixed(2);
    var withCommas = function (n, dec) {
      var parts = Number(n).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    };
    return (format || '{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withCommas(value, 0);
        case 'amount_with_comma_separator': return fixed2.replace('.', ',');
        case 'amount_no_decimals_with_comma_separator': return withCommas(value, 0).replace(/,/g, '.');
        default: return withCommas(value, 2);
      }
    });
  }

  function img(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    try { var u = new URL(url); u.searchParams.set('width', w); return u.toString(); } catch (e) { return url; }
  }

  customElements.define('wishlist-page', class extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.d = this.dataset;
      this.grid = this.querySelector('[data-wl-grid]');
      this.empty = this.querySelector('[data-wl-empty]');
      this.actions = this.querySelector('[data-wl-actions]');
      this.countEl = this.querySelector('[data-wl-count]');
      this.status = this.querySelector('[data-wl-status]');
      this.titleEl = this.querySelector('[data-wl-title]');
      this.products = new Map();

      var shared = new URLSearchParams(location.search).get('items');
      this.shared = shared ? shared.split(',').map(function (h) { return h.trim(); }).filter(Boolean).slice(0, 50) : null;

      this.querySelector('[data-wl-move-all]').addEventListener('click', this.moveAll.bind(this));
      this.querySelector('[data-wl-share]').addEventListener('click', this.share.bind(this));
      this.querySelector('[data-wl-clear]').addEventListener('click', this.clear.bind(this));
      this.querySelector('[data-wl-save-shared]').addEventListener('click', this.saveShared.bind(this));
      this.grid.addEventListener('click', this.onGridClick.bind(this));
      this.grid.addEventListener('change', this.onVariantChange.bind(this));

      var self = this;
      document.addEventListener('wishlist:change', function () { if (!self.shared && !self._busy) self.load(); });
      this.load();
    }

    handles() { return this.shared || store.get(); }

    announce(msg) {
      this.status.textContent = '';
      var s = this.status;
      setTimeout(function () { s.textContent = msg; }, 50);
    }

    async load() {
      var handles = this.handles();
      if (!handles.length) return this.render([]);
      this.grid.setAttribute('aria-busy', 'true');
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var self = this;
      var results = await Promise.all(handles.map(function (h) {
        if (self.products.has(h)) return Promise.resolve(self.products.get(h));
        return fetch(root + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      }));
      var found = [];
      var missing = false;
      results.forEach(function (p, i) {
        if (p) { self.products.set(handles[i], p); found.push(p); } else missing = true;
      });
      if (missing && !this.shared) {
        this._busy = true;
        store.set(found.map(function (p) { return p.handle; }));
        this._busy = false;
        this.announce(this.d.tUnavailable);
      }
      this.render(found);
    }

    render(list) {
      var n = list.length;
      this.grid.setAttribute('aria-busy', 'false');
      this.titleEl.textContent = this.shared ? this.d.tShared : this.titleEl.dataset.default;
      this.countEl.textContent = n === 0 ? '' : (n === 1 ? this.d.tCountOne : this.d.tCountOther.replace('[count]', n));
      this.empty.hidden = n > 0;
      this.grid.hidden = n === 0;
      this.actions.hidden = n === 0;
      this.querySelector('[data-wl-save-shared]').hidden = !this.shared;
      this.querySelector('[data-wl-clear]').hidden = !!this.shared;
      this.querySelector('[data-wl-share]').hidden = !!this.shared;
      this.grid.innerHTML = list.map(this.card.bind(this)).join('');
    }

    card(p) {
      var d = this.d;
      var variant = p.variants.find(function (v) { return v.available; }) || p.variants[0];
      var multi = p.variants.length > 1 && !(p.variants.length === 1 && variant.title === 'Default Title');
      var image = p.featured_image || (p.images && p.images[0]) || '';
      var options = multi ? p.variants.map(function (v) {
        return '<option value="' + v.id + '"' + (v.id === variant.id ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' + esc(v.title) + (v.available ? '' : ' – ' + esc(d.tSoldOut)) + '</option>';
      }).join('') : '';
      var save = variant.compare_at_price > variant.price ? Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) : 0;
      return '<li class="wl-card" data-handle="' + esc(p.handle) + '">' +
        '<div class="wl-card__media">' +
          '<a href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
            (image ? '<img class="wl-card__img" src="' + esc(img(image, 400)) + '" srcset="' + esc(img(image, 250)) + ' 250w, ' + esc(img(image, 400)) + ' 400w, ' + esc(img(image, 600)) + ' 600w" sizes="(min-width: 990px) 260px, 45vw" width="400" height="400" alt="" loading="lazy">' : '') +
          '</a>' +
          (save ? '<span class="wl-card__badge">-' + save + '%</span>' : '') +
          (this.shared ? '' : '<button type="button" class="wl-card__remove" data-wl-remove aria-label="' + esc(d.tRemove + ': ' + p.title) + '"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m6 5 13 13-1 1L5 6l1-1Zm12 0 1 1L6 19l-1-1L18 5Z" fill="currentColor"/></svg></button>') +
        '</div>' +
        '<div class="wl-card__body">' +
          (p.type ? '<p class="wl-card__type">' + esc(p.type) + '</p>' : '') +
          '<a class="wl-card__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<p class="wl-card__price" data-wl-price>' + this.priceHtml(variant) + '</p>' +
          (multi ? '<label class="wl-card__variant"><span>' + esc(d.tWeight) + '</span><select data-wl-variant aria-label="' + esc(d.tWeight + ' – ' + p.title) + '">' + options + '</select></label>' : '<input type="hidden" data-wl-variant value="' + variant.id + '">') +
          '<button type="button" class="wl__btn wl__btn--solid wl__btn--block wl-card__add" data-wl-add' + (variant.available ? '' : ' disabled') + '>' + esc(variant.available ? d.tAdd : d.tSoldOut) + '</button>' +
        '</div>' +
      '</li>';
    }

    priceHtml(v) {
      var f = this.d.moneyFormat;
      return esc(formatMoney(v.price, f)) + (v.compare_at_price > v.price ? '<s>' + esc(formatMoney(v.compare_at_price, f)) + '</s>' : '');
    }

    variantFor(card) {
      var p = this.products.get(card.dataset.handle);
      var id = Number(card.querySelector('[data-wl-variant]').value);
      return p && p.variants.find(function (v) { return v.id === id; });
    }

    onVariantChange(e) {
      if (!e.target.matches('[data-wl-variant]')) return;
      var card = e.target.closest('.wl-card');
      var v = this.variantFor(card);
      if (!v) return;
      card.querySelector('[data-wl-price]').innerHTML = this.priceHtml(v);
      var btn = card.querySelector('[data-wl-add]');
      btn.disabled = !v.available;
      btn.textContent = v.available ? this.d.tAdd : this.d.tSoldOut;
    }

    onGridClick(e) {
      var removeBtn = e.target.closest('[data-wl-remove]');
      var addBtn = e.target.closest('[data-wl-add]');
      if (removeBtn) this.remove(removeBtn.closest('.wl-card'));
      if (addBtn) this.addOne(addBtn.closest('.wl-card'), addBtn);
    }

    remove(card) {
      var handle = card.dataset.handle;
      var self = this;
      card.classList.add('is-leaving');
      this._busy = true;
      store.set(store.get().filter(function (h) { return h !== handle; }));
      this._busy = false;
      setTimeout(function () {
        card.remove();
        var left = self.grid.querySelectorAll('.wl-card').length;
        if (!left) self.render([]);
        else self.countEl.textContent = left === 1 ? self.d.tCountOne : self.d.tCountOther.replace('[count]', left);
        self.announce(self.d.tRemoved);
      }, 220);
    }

    async addItems(items) {
      var notify = document.querySelector('cart-notification');
      var sections = notify && notify.getSectionsToRender ? notify.getSectionsToRender().map(function (x) { return x.id; }) : [];
      var res = await fetch((this.d.cartAddUrl || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: sections, sections_url: location.pathname })
      });
      var data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Error');
      if (notify && notify.renderContents && data.sections) {
        notify.renderContents(data);
      } else {
        var cart = await (await fetch('/cart.js')).json();
        document.querySelectorAll('.header__actions_btn_cart_num, .cart-count-bubble span').forEach(function (el) { el.textContent = cart.item_count; });
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
      return data;
    }

    async addOne(card, btn) {
      var v = this.variantFor(card);
      if (!v) return;
      var d = this.d;
      btn.disabled = true;
      btn.textContent = d.tAdding;
      try {
        await this.addItems([{ id: v.id, quantity: 1 }]);
        btn.textContent = d.tAdded;
        this.announce(d.tAdded);
      } catch (err) {
        btn.textContent = err.message;
        this.announce(err.message);
      }
      setTimeout(function () { btn.textContent = d.tAdd; btn.disabled = false; }, 1800);
    }

    async moveAll(e) {
      var btn = e.currentTarget;
      var self = this;
      var items = [];
      this.grid.querySelectorAll('.wl-card').forEach(function (card) {
        var v = self.variantFor(card);
        if (v && v.available) items.push({ id: v.id, quantity: 1 });
      });
      if (!items.length) return;
      var label = btn.textContent;
      btn.disabled = true;
      try {
        await this.addItems(items);
        this.announce(this.d.tMoved);
        btn.textContent = this.d.tMoved;
      } catch (err) {
        this.announce(err.message);
      }
      setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 2000);
    }

    async share() {
      var url = location.origin + location.pathname + '?items=' + encodeURIComponent(store.get().join(','));
      try {
        if (navigator.share) { await navigator.share({ title: document.title, url: url }); return; }
        await navigator.clipboard.writeText(url);
        this.announce(this.d.tCopied);
        var b = this.querySelector('[data-wl-share]');
        var old = b.innerHTML;
        b.textContent = this.d.tCopied;
        setTimeout(function () { b.innerHTML = old; }, 2000);
      } catch (e) {
        window.prompt(this.d.tCopied, url);
      }
    }

    clear() {
      if (!window.confirm(this.d.tConfirmClear)) return;
      this._busy = true;
      store.set([]);
      this._busy = false;
      this.render([]);
    }

    saveShared() {
      var merged = store.get().concat(this.shared || []);
      store.set(merged.filter(function (h, i) { return merged.indexOf(h) === i; }));
      history.replaceState(null, '', location.pathname);
      this.shared = null;
      this.load();
    }
  });
})();
